import { reactive } from 'vue'
import axios from 'axios'
import { StoreBase } from '../StoreBase'

class MailAddressChangeStore implements StoreBase {
  /* eslint-disable class-methods-use-this */
  createStore() {
    const state = reactive({
      tokenId: '',
    })
    /**
     * メールアドレス変更をAPIに要求する。
     * @see https://pitchbase.atlassian.net/wiki/spaces/SL01/pages/1673822374/API
     * @return 送信結果。
     */
    const changeMailAddress = async () => {
      const result = await axios
        .put(
          `${process.env.VUE_APP_API_BASE_URL}/manage/mail_address_change_token/${state.tokenId}/change`,
          {},
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        .then(res => {
          return { isSuccess: true, res }
        })
        .catch(error => {
          let errRes = error
          // ネットワークエラー対策
          if (!errRes.response) {
            // eslint-disable-next-line @typescript-eslint/camelcase
            errRes = { response: { data: { error_code: 'NETWORK_ERROR' } } }
          }
          // eslint-disable-next-line prefer-promise-reject-errors
          return { isSuccess: false, res: errRes }
        })
      return result
    }

    return {
      changeMailAddress,
      /**
       * メールアドレス再設定用トークンID
       */
      get tokenId() {
        return state.tokenId
      },
      /**
       * メールアドレス再設定用トークンID
       * @param tokenId メールアドレス再設定用トークンID
       */
      set tokenId(tokenId: string) {
        state.tokenId = tokenId
      },
    }
  }
  /* eslint-enable class-methods-use-this */
}

export default new MailAddressChangeStore().createStore()
